import {Component, Input, OnInit} from '@angular/core';
import {SelectComponent} from 'web-shared';
import {IdCodeNameQuery} from 'common-shared';
import {ItemGroupQuery} from 'web-shared';
import {ItemQuery} from 'web-shared';
import {ManufacturingItemEditModalComponent} from '../manufacturing-item/manufacturing-item-edit-modal/manufacturing-item-edit-modal.component';
import {ManufacturingItemGroupEditModalComponent} from '../manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component';
import {ManufacturingItemGroupService} from '../manufactured-item-groups/manufacturing-item-group.service';
import {takeUntil} from "rxjs/operators";
import {ItemService} from "../../common/item/item.service";

@Component({
  selector: 'app-manufacturing-item-or-group-select',
  templateUrl: './manufacturing-item-or-group-select.component.html',
  styles: [':host {display: contents;}']
})
export class ManufacturingItemOrGroupSelectComponent extends SelectComponent<IdCodeNameQuery> implements OnInit {
  @Input() enableGroupAdd = true;
  @Input() enableItemAdd = true;
  @Input() allowItemGroups: boolean = false;
  showGroups: boolean = true;
  showItems: boolean = true;

  constructor(public itemService: ItemService, public itemGroupService: ManufacturingItemGroupService) {
    super();
  }

  ngOnInit(): void {
    this.ensureItems();
  }

  addNewGroup(searchTerm: string = null) {
    this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityName: searchTerm} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ManufacturingItemGroupEditModalComponent;
      this.setEntity(Object.assign(new ItemGroupQuery(), comp.manufacturedItemGroup));
    });
  }

  addNewItem(searchTerm: string = null) {
    this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityName: searchTerm} as ManufacturingItemEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ManufacturingItemEditModalComponent;
      this.setEntity(Object.assign(new ItemQuery(), comp.item));
    });
  }

  editExisting(model: ItemGroupQuery | ItemQuery) {
    if (model instanceof ItemGroupQuery) {
      this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: this.entityId || this.entityIds[0]} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
        const comp = bsModalRef.content as ManufacturingItemGroupEditModalComponent;
        if (!this.multiple) {
          const entity = comp.manufacturedItemGroup ? Object.assign(new ItemGroupQuery(), comp.manufacturedItemGroup) : null;
          this.setEntity(entity);
        }
      });
    } else {
      this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityId: this.entityId || this.entityIds[0]} as ManufacturingItemEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
        const comp = bsModalRef.content as ManufacturingItemEditModalComponent;
        if (!this.multiple) {
          const entity = comp.item ? Object.assign(new ItemQuery(), comp.item) : null;
          this.setEntity(entity);
        }
      });
    }
  }

  onSelectionChanged($event: ItemGroupQuery[] | ItemGroupQuery | ItemQuery[] | ItemQuery) {
    if (this.multiple) {
      const items = $event as IdCodeNameQuery[];
      if (items && items.length) {
        this.entityIdsChange.emit(items.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      let item = $event as IdCodeNameQuery;
      this.setEntity(item);
    }
  }

  ensureItems() {
    if (this.allowItemGroups) {
      if (this.showItems && this.showGroups) {
        this.items$ = this.itemService.getItemsCombinedToGroups$;
      }
      else if (this.showItems) {
        this.items$ = this.itemService.getNotDrafts$;
      }
      else if (this.showGroups) {
        this.items$ = this.itemGroupService.getNotDrafts$;
      }
    } else {
      this.items$ = this.itemService.getItemsWithAlternativeGroups$;
    }
    this.refreshToken$.next(undefined);
  }
}
